export function getMonthName(monthOffset: number = 0): string {
  const date = new Date();
  date.setMonth(date.getMonth() + monthOffset);
  return date
    .toLocaleString("es-ES", { month: "long", year: "numeric" })
    .toUpperCase();
}

export function formatShortNumber(input: string | number): string {
  const num =
    typeof input === "number"
      ? input
      : Number(input.toString().replace(/\D/g, ""));
  if (isNaN(num) || num === null) return "0";
  if (num >= 1_000_000_000) return (num / 1_000_000_000).toFixed(2) + "B";
  if (num >= 1_000_000)
    return (num / 1_000_000).toFixed(num % 1_000_000 === 0 ? 0 : 2) + "M";
  if (num >= 1_000)
    return (num / 1_000).toFixed(num % 1_000 === 0 ? 0 : 2) + "K";
  return num.toLocaleString("es-ES");
}

export function formatChatDate(date: string | Date): string {
  const now = new Date();
  const input = new Date(date);

  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const inputDay = new Date(
    input.getFullYear(),
    input.getMonth(),
    input.getDate()
  );

  const diffDays = Math.round(
    (today.getTime() - inputDay.getTime()) / (1000 * 60 * 60 * 24)
  );

  if (diffDays === 0) {
    return new Intl.DateTimeFormat("es-ES", {
      hour: "2-digit",
      minute: "2-digit",
    }).format(input);
  } else if (diffDays === 1) {
    return "ayer";
  } else {
    return new Intl.DateTimeFormat("es-ES", {
      day: "2-digit",
      month: "2-digit",
      year: "2-digit",
    }).format(input);
  }
}
